// extracted by mini-css-extract-plugin
export default {"timeApproveEmptyState":"TimeApproveEmptyState_timeApproveEmptyState__f4l7V"};